/* B3 Marquee loghi — riempimento della traccia.

   Perché non il componente nativo marquee-component:
   - la sua durata è sqrt(numeroCopie) * data-speed-factor, quindi da un
     valore in secondi non si ottiene una durata prevedibile: cambia con
     quante copie entrano nello schermo;
   - la pausa al passaggio del mouse è cablata dentro il componente
     (pointerenter/pointerleave) e non si può spegnere da fuori, mentre qui
     serve un interruttore;
   - richiede il contratto interno di Horizon (requiredRefs wrapper/content/
     marqueeItems, la sintassi ref="marqueeItems[]", l'importmap di
     @theme/component), e i suoi stili stanno nel {% stylesheet %} di
     sections/marquee.liquid.
   Lo scorrimento è quindi un'animazione CSS su due metà identiche stampate
   dal server; questo file si limita a moltiplicare le copie dentro ciascuna
   metà quando i loghi non bastano a riempire lo schermo. Senza JS il nastro
   scorre lo stesso, solo con meno copie. */
(function () {
  var MAX_COPIE = 12;

  function riempi(root) {
    var viewport = root.querySelector('[data-b3-marquee-viewport]');
    var meta = root.querySelectorAll('[data-b3-marquee-meta]');
    if (!viewport || meta.length < 2) return;

    var larghezzaViewport = viewport.clientWidth;
    if (!larghezzaViewport) return;

    /* Alla prima passata si mette da parte il contenuto originale di ogni
       metà: le passate successive ripartono da lì invece di accumulare. */
    for (var i = 0; i < meta.length; i++) {
      if (!meta[i].b3Originale) {
        meta[i].b3Originale = Array.prototype.map.call(meta[i].children, function (figlio) {
          return figlio.cloneNode(true);
        });
      }
    }

    var larghezzaMeta = meta[0].scrollWidth;
    if (!larghezzaMeta) return;

    var copie = Math.ceil(larghezzaViewport / larghezzaMeta);
    if (copie < 1) copie = 1;
    if (copie > MAX_COPIE) copie = MAX_COPIE;

    if (String(copie) === root.dataset.copie) return;
    root.dataset.copie = String(copie);

    for (var m = 0; m < meta.length; m++) {
      var originale = meta[m].b3Originale;
      var frammento = document.createDocumentFragment();
      for (var c = 0; c < copie; c++) {
        for (var k = 0; k < originale.length; k++) {
          frammento.appendChild(originale[k].cloneNode(true));
        }
      }
      meta[m].textContent = '';
      meta[m].appendChild(frammento);
    }
  }

  function initMarquee(root) {
    if (root.dataset.marqueeInit === 'true') return;
    root.dataset.marqueeInit = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* Le immagini dei loghi sono lazy: la larghezza reale della metà si
       conosce solo a caricamento avvenuto, quindi si ricalcola anche dopo. */
    riempi(root);
    window.addEventListener('load', function () {
      riempi(root);
    });

    var attesa = null;
    window.addEventListener('resize', function () {
      clearTimeout(attesa);
      attesa = setTimeout(function () {
        riempi(root);
      }, 200);
    });
  }

  function init() {
    document.querySelectorAll('[data-b3-marquee]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-b3-marquee]') : null;
    if (root) {
      root.dataset.marqueeInit = '';
      root.dataset.copie = '';
      initMarquee(root);
    }
  });
})();
